import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("cashflow_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [checking, setChecking] = useState(!!localStorage.getItem("cashflow_token"));

  useEffect(() => {
    const token = localStorage.getItem("cashflow_token");
    if (!token) {
      setChecking(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data);
        localStorage.setItem("cashflow_user", JSON.stringify(data));
      })
      .catch(() => {
        localStorage.removeItem("cashflow_token");
        localStorage.removeItem("cashflow_user");
        setUser(null);
      })
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("cashflow_token", data.token);
      const u = { email: data.email, name: data.name, role: data.role || "admin" };
      localStorage.setItem("cashflow_user", JSON.stringify(u));
      setUser(u);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem("cashflow_token");
    localStorage.removeItem("cashflow_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
